// extracted by mini-css-extract-plugin
export default {"zoomModal":"p1-z"};